$(document).ready(function () {
    document.onreadystatechange = function () {
        if (document.readyState === "complete") {
            $('img:not([alt])').attr('alt', '');
        } else {
            window.onload = function () {
                $('img:not([alt])').attr('alt', '');
            };
        };
      $('.icon-sub-menu').attr('tabindex','0');
      $('.icon-sub-menu').attr('aria-label','expand dropdown');
      $('.icon-sub-menu').attr('onkeypress','javascript: if(event.keyCode == 13) jQuery(this).click();');
    }
    
    $('#menu').keypress(function(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13'){
        $(this).click();
      }
    });
    $('#menu').click(function(event){
        $('#mobilemenu').toggle();
        $('#mobilemenu').focus();
    });
    $('.basel-close-side').click(function(event){
        $('#mobilemenu').toggle();
    });
  
});